var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33295 0H118.714C120.461 0 122.022 0.955375 123.157 2.48243C124.289 4.00949 125 6.1745 125 8.46431V116.536C125 118.89 124.289 120.991 123.157 122.519C123.063 122.645 122.967 122.773 122.826 122.9C121.738 124.237 120.275 125 118.667 125H6.28604C4.53776 125 2.97712 124.046 1.84325 122.519C0.709382 120.992 0 118.829 0 116.537V8.46585C0 6.11132 0.709382 4.01103 1.84325 2.48398C2.97712 0.956918 4.58467 0.00154212 6.28604 0.00154212L6.33295 0ZM32.286 29.3423C37.2677 29.3423 41.3043 34.7787 41.3043 41.4879C41.3043 48.1971 37.2677 53.6351 32.286 53.6351C27.3043 53.6351 23.2677 48.1971 23.2677 41.4879C23.2666 34.7803 27.3043 29.3423 32.286 29.3423ZM70.2391 81.4673L88.278 39.4647L107.441 104.743L18.0069 104.741V96.6454L25.524 96.1415L33.0378 71.3434L36.7929 89.0579H48.0687L57.8364 55.1513L70.2391 81.4673ZM117.532 10.0576H7.51373V114.882H117.531L117.532 10.0576Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy);
export default __webpack_public_path__ + "static/media/dummy.c701cb7c3a94301841e4c43314260408.svg";
export { ForwardRef as ReactComponent };